/**
 * Fiskal Cloud Management Admin API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.1.0
 * Contact: info@deutsche-fiskal.de
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Status:  * `active` - Active client serving requests  * `disabled` - Client is disabled and no fiscal api access is allowed for this client  * `inactive` - Client was created but is inactive. Only user read access to fiscal api allowed  * `suspended` - ERS was suspended. Usage suspended, license usage paused. Authentication to FCC disabled  * `deleted` - Client was deleted and is not accessible anymore and is visible only in special views 
 */
export enum ErsStatusEnumDTO {
    ACTIVE = 'active',
    DISABLED = 'disabled',
    INACTIVE = 'inactive',
    SUSPENDED = 'suspended',
    DELETED = 'deleted'
}

export class ClsErsStatusEnumDTO {
    ACTIVE = 'active';
    DISABLED = 'disabled';
    INACTIVE = 'inactive';
    SUSPENDED = 'suspended';
    DELETED = 'deleted';
}

